import { cn } from '../../lib/utils';
import { useMemo } from 'react';

type Phase = 'rest' | 'damage' | 'hold' | 'unwarp' | 'heal' | 'fade';

export const Meteors = ({
  number,
  className,
  phase,
}: {
  number?: number;
  className?: string;
  phase?: Phase;
}) => {
  const isDamage = phase === 'damage' || phase === 'hold';
  const isHeal = phase === 'heal';

  const meteors = useMemo(() => {
    const count = number || 20;
    // Flat uniform horizontal distribution across the full width.
    // Top still mildly biased to upper area (meteors should rain DOWN from the top).
    const biased = () => (Math.random() + Math.random()) / 2;
    return Array.from({ length: count }, () => ({
      top: biased() * 60,
      // Uniform random across near-full width (-5 to 95 — negative allows meteors
      // to appear to enter from just off-screen left, since they rotate -35° and
      // animate diagonally toward the bottom-left).
      left: -5 + Math.random() * 100,
      delay: Math.random() * 10 + 0.5,
      duration: Math.random() * 5 + 8,
    }));
  }, [number]);

  return (
    <>
      {meteors.map((m, idx) => (
        <span
          key={'meteor' + idx}
          className={cn(
            // Square meteors (no rounded corners) so they look like pixel art chunks
            'animate-meteor-effect absolute rotate-[215deg]',
            className
          )}
          style={{
            top: m.top + '%',
            left: m.left + '%',
            width: isHeal ? 6 : 4,
            height: isHeal ? 6 : 4,
            animationDelay: m.delay + 's',
            animationDuration: m.duration + 's',
            animationPlayState: isHeal ? 'paused' : 'running',
            backgroundColor: isDamage ? '#FF4444' : isHeal ? '#50E6B4' : '#94a3b8',
            boxShadow: isHeal
              ? '0 0 8px 3px rgba(80,230,180,0.7)'
              : isDamage
              ? '0 0 6px 1px rgba(255,80,80,0.4)'
              : '0 0 4px 1px rgba(148,163,184,0.25)',
            transition: isDamage ? 'none' : 'background-color 0.8s ease-out, width 0.6s ease-out, height 0.6s ease-out, box-shadow 0.8s ease-out',
          }}
        >
          {/* Chunky tail — thicker height so it survives pixelation */}
          <span
            className="absolute top-1/2 -translate-y-1/2"
            style={{
              width: isHeal ? 0 : 60,
              height: 3,
              background: isDamage
                ? 'linear-gradient(to right, #FF4444, transparent)'
                : isHeal
                ? 'linear-gradient(to right, #50E6B4, transparent)'
                : 'linear-gradient(to right, #94a3b8, transparent)',
              transition: isDamage ? 'none' : 'width 0.5s ease-out, background 0.8s ease-out',
            }}
          />
        </span>
      ))}
    </>
  );
};
